/**
 * Phase 36da.99.uc — UoM Chain master client.
 *
 * Endpoints mirror uomApi so the UI patterns (active/all, CRUD,
 * toggle-status) translate one-to-one between the two masters.
 */
import API from "./axios";

const uomChainApi = {
  getAll:       ()       => API.get("/uom-chain"),
  getActive:    ()       => API.get("/uom-chain/active"),
  getById:      (id)     => API.get(`/uom-chain/${id}`),
  create:       (data)   => API.post("/uom-chain", data),
  update:       (id, d)  => API.put(`/uom-chain/${id}`, d),
  toggleStatus: (id)     => API.patch(`/uom-chain/${id}/toggle-status`),
  delete:       (id)     => API.delete(`/uom-chain/${id}`),
};

export default uomChainApi;